import useUpdateProfile from "api/UserResource/useUpdateProfile";
// import { AvatarInput } from "components";
import { Form, Formik } from "formik";
import { MAX_IMAGE_SIZE, phoneRegex } from "utils";
import * as Yup from "yup";
import FormField from "components/v2/FormField";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import moment from "moment";
import useSearchParams from "hooks/useSearchParams";

const UpdateProfile = ({ userId, firstName, lastName, mobileNumber, dob, sex }) => {
	const { getParam } = useSearchParams();

	const returnUrl = getParam("returnUrl") || "";

	const initialValues = {
		first_name: firstName || "",
		last_name: lastName || "",
		mobile_number: mobileNumber || "",
		dob: dob || "",
		sex: sex || "",
		avatar: null,
	};

	const validateSchema = Yup.object().shape({
		first_name: Yup.string().required("First name is required"),
		last_name: Yup.string().required("Surname is required"),
		mobile_number: Yup.string()
			.matches(phoneRegex, "Invalid phone number")
			.min(10, "Mobile number must have at least 10 characters")
			.max(20, "Mobile number cannot exceed 20 characters"),
		dob: Yup.string().matches(
			/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
			"Invalid date format"
		),
		avatar: Yup.mixed()
			.nullable()
			.test("fileSize", `Image size should not exceed ${MAX_IMAGE_SIZE}MB`, (value) => {
				if (!value) return true;
				return value.size / 1024 / 1024 <= MAX_IMAGE_SIZE;
			})
			.test("fileMimeType", "Only png, jpg, or jpeg document is required", (value) => {
				if (!value) return true;
				return (
					value.type === "image/png" ||
					value.type === "image/jpeg" ||
					value.type === "image/svg+xml" ||
					value.type === "image/webp"
				);
			}),
	});

	const { mutateAsync, isLoading } = useUpdateProfile(userId, returnUrl);

	const handleUpdateProfile = async (data) => {
		await mutateAsync(data);
	};

	return (
		<>
			<div>
				<Formik
					initialValues={initialValues}
					validationSchema={validateSchema}
					onSubmit={(data) => handleUpdateProfile(data)}
				>
					{(formik) => (
						<Form className="space-y-8">
							{/* Personal Information Section */}
							<div className="space-y-6">
								<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
									<div className="space-y-2">
										<FormField
											name="first_name"
											label="First Name *"
											// placeholder="Enter your first name"
											// classNames={{
											// 	label: "text-sm font-medium text-gray-700 mb-2 block",
											// 	input:
											// 		"w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-1 focus:ring-gray-400 focus:border-gray-400 transition-all duration-200 text-gray-900",
											// }}
										/>
									</div>
									<div className="space-y-2">
										<FormField
											name="last_name"
											label="Last Name *"
											// placeholder="Enter your last name"
											// classNames={{
											// 	label: "text-sm font-medium text-gray-700 mb-2 block",
											// 	input:
											// 		"w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-1 focus:ring-gray-400 focus:border-gray-400 transition-all duration-200 text-gray-900",
											// }}
										/>
									</div>
								</div>

								<div className="space-y-2">
									<FormField
										name="mobile_number"
										type="phone"
										label="Phone Number"
										// placeholder="Enter your phone number"
										value={formik.values.mobile_number}
										_onChange={(phone) => {
											if (phone !== "+") formik.values.mobile_number = "+" + phone;
											else formik.values.mobile_number = phone;
										}}
										error={Boolean(formik.errors.mobile_number && formik.touched.mobile_number)}
										errorText={formik.errors.mobile_number}
										classNames={{
											label: "text-sm font-medium text-gray-700 mb-2 block",
										}}
									/>
								</div>

								<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
									<div className="space-y-2">
										<FormField
											name="dob"
											type="date"
											label="Date of Birth"
											value={formik.values.dob}
											onChange={(e) =>
												formik.setFieldValue("dob", moment(e.target?.value).format("YYYY-MM-DD"))
											}
											classNames={{
												label: "text-sm font-medium text-gray-700 mb-2 block",
												input:
													"w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-1 focus:ring-gray-400 focus:border-gray-400 transition-all duration-200 text-gray-900",
											}}
										/>
									</div>
									<div className="space-y-2">
										<FormField
											type="select"
											name="sex"
											label="Gender"
											placeholder="Select gender"
											options={[
												{ label: "Male", value: "Male" },
												{ label: "Female", value: "Female" },
											]}
											// classNames={{
											// 	label: "text-sm font-medium text-gray-700 mb-2 block",
											// 	input:
											// 		"w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-1 focus:ring-gray-400 focus:border-gray-400 transition-all duration-200 text-gray-900",
											// }}
										/>
									</div>
								</div>
							</div>

							{/* Submit Button */}
							<div className="pt-6 border-t border-gray-100">
								<button
									type="submit"
									disabled={isLoading}
									className="w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-akgreen to-akgreener text-white font-medium rounded-xl hover:from-akgreener hover:to-akgreen focus:outline-none focus:ring-2 focus:ring-akgreen focus:ring-offset-2 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center gap-2 min-w-[160px]"
								>
									{isLoading ? (
										<>
											<AiOutlineLoading3Quarters size={18} className="animate-spin" />
											<span>Updating...</span>
										</>
									) : (
										<>
											<svg
												className="w-4 h-4"
												fill="none"
												stroke="currentColor"
												viewBox="0 0 24 24"
											>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth={2}
													d="M5 13l4 4L19 7"
												/>
											</svg>
											<span>Update Profile</span>
										</>
									)}
								</button>
							</div>
						</Form>
					)}
				</Formik>
			</div>
		</>
	);
};

export default UpdateProfile;
